import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  paper: {
    marginTop: 24,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
  },
  topFieldContainer: {
    display: 'flex',
    padding: '16px 32px',
    alignItems: 'center',
    gap: 16,
  },
  form: {
    display: 'flex',
    flexFlow: 'column',
    padding: '16px 32px',
  },
};

export default styles;
